
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","stroke":"#000","opacity":".4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.916 8.333c0-3.142 0-4.714 1.037-5.69C4.991 1.667 6.66 1.667 10 1.667h.644c2.718 0 4.077 0 5.02.664.27.191.51.417.713.671.707.889.707 2.167.707 4.725v2.121c0 2.47 0 3.704-.391 4.69-.628 1.586-1.957 2.836-3.641 3.427-1.048.368-2.36.368-4.983.368-1.5 0-2.25 0-2.848-.21-.962-.338-1.722-1.052-2.08-1.958-.224-.564-.224-1.27-.224-2.68V8.333z","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.083 10a2.778 2.778 0 01-2.777 2.778c-.555 0-1.21-.097-1.749.047-.48.129-.854.503-.982.982-.144.54-.047 1.194-.047 1.749a2.778 2.778 0 01-2.778 2.777M6.666 5.833h5.833M6.666 9.167h2.5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    